import { useNavigate } from "react-router-dom";
import {
  PageWizardProvider,
  PageWizardRoutes,
} from "shared/components/layout/PageWizard";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const HybridWaterfallPage: React.FC = () => {
  const navigate = useNavigate();

  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();

  const navigateToActivityEvent = () => {
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .capitalActivity({})
        .capitalActivityEvent({ fundFamilyEventId }).$,
    );
  };

  return (
    <PageWizardProvider allowNavigate={false} onExit={navigateToActivityEvent}>
      <PageWizardRoutes />
    </PageWizardProvider>
  );
};
